export const JIRA_PORTAL = `${import.meta.env.VITE_JIRA_PORTAL_URL}/${import.meta.env.VITE_JIRA_PORTAL_ID}`;
